export enum SegmentFormType {
  OneWay = "OneWay",
  Return = "Return",
  MultiSegment = "MultiSegment"
}
